import React from "react";
import styled from "styled-components";
import { Table as BsTable, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RUTA_RESERVAS_HOTEL } from "../../../services/rutas";
import { AgendamientoListado } from "../../../services/agendamientosGuarderiaServicios";
import { formatearFechaStr } from "../../../utils/dateUtils";

interface TableSectionProps {
  agendamientos: AgendamientoListado[];
  isLoading: boolean;
}

function Table({ agendamientos, isLoading }: TableSectionProps) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Mascota</StyledColHeader>
          <StyledColHeader>Fecha Realización</StyledColHeader>
          <StyledColHeader>Tarifa</StyledColHeader>
        </tr>
      </thead>
      {isLoading && (
        <tbody>
          <LoadingTableItem />
        </tbody>
      )}
      {
        !isLoading && (
          <tbody>
            {agendamientos.map((_, index) => (
              <TableItem key={_.id} agendamiento={_} />
            ))}
          </tbody>
        )
      }
    </StyledTable>
  );
}


interface TableItemProps {
  agendamiento: AgendamientoListado;
}

function LoadingTableItem() {
  return (
    <StyledRow>
      <StyledCell><Spinner animation="border" size="sm" /></StyledCell>
      <StyledCell><Spinner animation="border" size="sm" /></StyledCell>
      <StyledCell><Spinner animation="border" size="sm" /></StyledCell>
      <StyledCell><Spinner animation="border" size="sm" /></StyledCell>
    </StyledRow>
  );
}

function TableItem({ agendamiento }: TableItemProps) {
  let navigate = useNavigate();

  return (
    <StyledRow
      onClick={() => navigate(`${RUTA_RESERVAS_HOTEL}/${agendamiento.id}`, { replace: false })}
      className={agendamiento.fueCancelado ? "table-danger" : ""}
    >
      <StyledCell>{agendamiento.nombrePropietario}</StyledCell>
      <StyledCell>{agendamiento.nombreMascota}</StyledCell>
      <StyledCell>{formatearFechaStr(agendamiento.fechaRealizacion)}</StyledCell>
      <StyledCell>{agendamiento.nombreServicio}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
